// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ge7K","col":"styles_col__3IWfn"};